// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2JD47","colMin":"styles_colMin__7NNvC","colCheckbox":"styles_colCheckbox__17z_7"};